/* Scroll motion. Runs only when GSAP loaded and the visitor has not asked for reduced motion.
   Reveals: .reveal-clip elements unmask downward when scrolled into view.
   The hero headline's load animation is pure CSS (base.css) so it never waits for this file. */

(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !window.gsap) return;

  const { gsap } = window;
  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

  function reveals(scope = document) {
    if (!window.ScrollTrigger) return;
    scope.querySelectorAll('.reveal-clip').forEach((el) => {
      if (el.dataset.motionDone) return;
      el.dataset.motionDone = 'true';
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) return;
      gsap.fromTo(el, { clipPath: 'inset(0 0 100% 0)' }, {
        clipPath: 'inset(0 0 0% 0)',
        duration: 1.2,
        ease: 'power3.inOut',
        clearProps: 'clipPath',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      });
      const img = el.querySelector('img');
      if (img) {
        gsap.fromTo(img, { scale: 1.12 }, {
          scale: 1,
          duration: 1.6,
          ease: 'power3.out',
          clearProps: 'transform',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        });
      }
    });
  }

  reveals();

  document.addEventListener('shopify:section:load', (event) => {
    reveals(event.target);
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  });

  window.themeMotion = { reveals };
})();
